// Voice used by the scan stations. The customer's smile name is written in English, so a
// Thai voice is picked explicitly — setting `lang` alone only *requests* Thai, and the
// browser silently falls back to an English voice, which also reads "12" as "twelve".
// Digits are spoken one by one in Thai instead ("12" → "หนึ่ง สอง").
// Needs a Thai voice installed on the PC (Settings → Speech → Add voices → ไทย).

const THAI_DIGITS = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];

const toThaiDigits = (text) =>
  text.replace(/\d/g, (d) => ` ${THAI_DIGITS[Number(d)]} `).replace(/\s+/g, ' ').trim();

export const speakThai = (text) => {
  if (!text || !window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(toThaiDigits(String(text)));
  utterance.lang = 'th-TH';
  utterance.rate = 0.9;
  const thaiVoice = (window.speechSynthesis.getVoices() || []).find((v) =>
    v.lang?.toLowerCase().startsWith('th'));
  if (thaiVoice) utterance.voice = thaiVoice;
  window.speechSynthesis.speak(utterance);
};
